import styled from 'styled-components';
import { TextArea } from 'ui/inputs/textArea/TextArea';
import { Select } from 'ui/selectv2/Select';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledSelect = styled(Select)`
  z-index: 1000;

  .dashboard-select__option-label {
    display: flex;
    align-items: center;
  }

  .dashboard-select__option,
  .dashboard-select__single-value {
    svg {
      height: ${pxToRem(20)};
      width: ${pxToRem(20)};
      margin: -${pxToRem(5)} ${pxToRem(10)} -${pxToRem(5)} 0;
      vertical-align: middle;
    }
  }
`;

export const StyledTextArea = styled(TextArea)<{ $isMarkdownArea?: boolean }>`
  &&& {
    textarea {
      min-height: ${({ $isMarkdownArea }) => ($isMarkdownArea ? pxToRem(300) : pxToRem(100))};
      resize: none;
    }
  }
`;

export const Label = styled.label`
  &&&& {
    display: flex;
    align-items: center;
    gap: ${spacing.quarter};
  }
`;
